import { apiClient } from './client';
import type { ApiResponse, User } from '@shared/types';

export const usersApi = {
  list: (params?: { role?: string }) =>
    apiClient.get<ApiResponse<User[]>>('/users', { params }),

  search: (keyword: string, role?: string) =>
    apiClient.get<ApiResponse<User[]>>('/users/search', {
      params: { keyword, role },
    }),
};
